import { LOAD_VARIATION_WITH_OVERRIDE, OVERRIDES_APPLIED } from "../actions";
import decodeOverride from "../services/override";

const initialState = {
  colors: [],
  textelements: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_VARIATION_WITH_OVERRIDE:
      var override = decodeOverride(action.payload.override);
      return {
        ...state,
        ...override,
      };
    case OVERRIDES_APPLIED:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
